import {isNotNil} from 'ramda';

import {ROWS_PER_PAGE} from '../constants/rowsPerPage';
import {UserListLinksResponseBody} from '../types';

export const hasMoreUserListPages = <T>(page: {data: T[]; links: UserListLinksResponseBody}) =>
  page.links.hasMore ??
  (isNotNil(page.links.totalCount)
    ? page.links.offset + page.data.length < page.links.totalCount
    : // Without either server boundary, a full final page requires one empty-page probe.
      page.data.length >= ROWS_PER_PAGE);
